// Nav.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import '../Styles/Nav.css';

const Nav = () => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className='nav-bar'>
      <a href="/" onClick={() => scrollToSection('Home')}>
        <img src={''} alt="Logo" />
      </a>
      <ul className='nav-ul'>
        <li className='nav-li'>
          <NavLink to="/" exact activeClassName="active-link" onClick={() => scrollToSection('Home')}>
            Home
          </NavLink>
        </li>
        <li className='nav-li'>
          <NavLink to="/about_us" activeClassName="active-link" onClick={() => scrollToSection('About')}>
            About Us
          </NavLink>
        </li>
        <li className='nav-li'>
          <NavLink to="/contact_us" activeClassName="active-link" onClick={() => scrollToSection('Contact')}>
            Contact Us
          </NavLink>
        </li>
        <li className='nav-li'>
          <NavLink to="/restaurant" activeClassName="active-link" onClick={() => scrollToSection('Restaurant')}>
            Restaurant
          </NavLink>
        </li>
      </ul>
      <button>
        <NavLink to="/book_now" activeClassName="active-link" onClick={() => scrollToSection('Booking')}>
          Book Now
        </NavLink>
      </button>
    </nav>
  );
};

export default Nav;
